module.exports = __webpack_public_path__ + "img/Accessibility-settings_Fr.a62f1458.png";